import { __ } from "@wordpress/i18n";

export const BROWSER_BEHAVIOR = [
	{
		id: "MobileDevice",
		name: __("Mobile Device", "dxp"),
		typeID: "BrowserBehavior",
		details:
			"This rule applies to visitors that are browsing your website from a mobile device, excluding tablets.",
	},
	{
		id: "TabletDevice",
		name: __("Tablet Device", "dxp"),
		typeID: "BrowserBehavior",
		details:
			"This rule applies to visitors that are browsing your website from a tablet device, excluding laptops & notebooks.",
	},
	{
		id: "DesktopDevice",
		name: __("Desktop Device", "dxp"),
		typeID: "BrowserBehavior",
		details:
			"This rule applies to visitors that are browsing your website from a desktop device, including laptops & notebooks.",
	},
	{
		id: "BrowserLanguage",
		multi: true,
		name: __("Browser Language", "dxp"),
		typeID: "BrowserBehavior",
		premium: true,
		details:
			"This rule applies to visitors that have their browser configured in the language you select above.",
	},
	{
		id: "BrowserCookie",
		multi: true,
		name: __("Browser Cookie", "dxp"),
		typeID: "BrowserBehavior",
		premium: true,
		details:
			"This rule applies to visitors that have a cookie saved in their browser with the name and value you configured above. <br> Learn more about cookies <a href='https://policies.google.com/technologies/cookies' target='_blank' rel='nofollow' title='What are cookies?'>here</a>.",
	},
	{
		id: "macOS",
		name: __("macOS Operating System", "dxp"),
		typeID: "BrowserBehavior",
		premium: true,
		details:
			"This rule applies to visitors that are using the macOS operating system.",
	},
	{
		id: "Windows",
		name: __("Windows Operating System", "dxp"),
		typeID: "BrowserBehavior",
		premium: true,
		details:
			"This rule applies to visitors that are using the Windows operating system.",
	},
	{
		id: "Linux",
		name: __("Linux Operating System", "dxp"),
		typeID: "BrowserBehavior",
		premium: true,
		details:
			"This rule applies to visitors that are using the Linux operating system.",
	},
	{
		id: "iOS",
		name: __("iOS Operating System", "dxp"),
		typeID: "BrowserBehavior",
		premium: true,
		details:
			"This rule applies to visitors that are using the iOS operating system.",
	},
	{
		id: "Android",
		name: __("Android Operating System", "dxp"),
		typeID: "BrowserBehavior",
		premium: true,
		details:
			"This rule applies to visitors that are using the Android operating system.",
	},
	{
		id: "CommonReferrers",
		name: __("Common Referral Website", "dxp"),
		typeID: "BrowserBehavior",
		premium: true,
		details:
			"This rule applies to visitors that were referred to you by a common website, such as Google or Facebook.",
	},
	{
		id: "CustomReferrers",
		multi: true,
		name: __("Custom Referral Website", "dxp"),
		typeID: "BrowserBehavior",
		details:
			"This rule applies to visitors that were referred to you by a custom website.",
	},
	{
		id: "PageReferrers",
		multi: true,
		name: __("Internal Referral (Page on your website)", "dxp"),
		typeID: "BrowserBehavior",
		details:
			"This rule applies to visitors that were referred to you by a page on your website.",
	},
	{
		id: "GeoCountry",
		name: __("Country", "dxp"),
		typeID: "BrowserBehavior",
		premium: true,
		details:
			"This rule applies to visitors that are browsing your website from the country you select above.",
	},
];
